import React from 'react';
import { Typography } from '@mui/material';

import { UserProfileType } from 'types';

import styles from './CurrentAddress.module.scss';

interface CurrentAddressProps {
    userProfile: UserProfileType;
}

export const CurrentAddress: React.FC<CurrentAddressProps> = ({ userProfile }) => (
    <div className={styles.profileAddressCurrent}>
        <Typography className={styles.itemValue}>{userProfile.addressLine1}</Typography>
        <Typography className={styles.itemValue}>{userProfile.addressLine2}</Typography>
        <Typography className={styles.itemValue}>
            {userProfile.city}, {userProfile.state}
        </Typography>
        <Typography className={styles.itemValue}>{userProfile.postalCode}</Typography>
    </div>
);
